export interface IPlaceholderColors {
  [key: string]: string;
}

export type PlaceholderColor = 'purple' | 'black' | 'dark purple' | 'grey';

export enum PlaceholderColors {
  purple,
  black,
  'dark purple',
  grey,
}

export const DefaultPlaceholderColor: PlaceholderColor = 'purple';

export function mapColor(color?: string | null): PlaceholderColor {
  if (!color) {
    return DefaultPlaceholderColor;
  }

  if (Object.values(PlaceholderColors).includes(color.toLowerCase())) {
    return color.toLowerCase() as PlaceholderColor;
  }

  return DefaultPlaceholderColor;
}
